import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import DatePicker from 'react-date-picker';
import Rodal from 'rodal';

import { STATE_TO_ABBREV } from '../../../constants';

import './style.scss';

const NewElection = (props) => {
  const {
    createElection,
    history,
    isLoggedIn,
  } = props;

  const [electionTitle, setElectionTitle] = useState('');
  const [electionState, setElectionState] = useState(Object.keys(STATE_TO_ABBREV)[0] || '');
  const [electionDate, setElectionDate] = useState(new Date());

  const [errorText, setErrorText] = useState('');
  const [modalVisible, setModalVisible] = useState(false);
  const [successModalVisible, setSuccessModalVisible] = useState(false);

  useEffect(() => {
    if (!isLoggedIn) {
      setModalVisible(true);
    } else {
      setModalVisible(false);
    }
  }, [isLoggedIn]);

  const valueSetter = setter => (e) => {
    setter(e.target.value);
    setErrorText('');
  };

  const onSubmitPress = () => {
    const fields = {
      title: electionTitle,
      state: STATE_TO_ABBREV[electionState],
      date: electionDate.toISOString(),
      races: [],
      polling_locations: [],
    };

    if (!electionTitle) return setErrorText('Please provide a title for the election');

    return createElection(fields, () => {
      setSuccessModalVisible(true);
    }, (err) => {
      if (err.response.data === 'Unauthorized') {
        setErrorText('You must be signed in to report an election');
      } else {
        setErrorText(JSON.stringify(err.response.data));
      }
    });
  };

  return (
    <div id="new-election-content">
      <h1>Report An Election</h1>
      <div id="content-container">
        <table>
          <tr>
            <th>Title of Election</th>
            <th>
              <input className="val" value={electionTitle} onChange={valueSetter(setElectionTitle)} />
            </th>
          </tr>
          <tr>
            <th>State</th>
            <th>
              <select className="val" value={electionState} onChange={valueSetter(setElectionState)}>
                {Object.keys(STATE_TO_ABBREV).map(stateName => <option key={stateName}>{stateName}</option>)}
              </select>
            </th>
          </tr>
          <tr>
            <th>Date of Election</th>
            <th>
              <DatePicker
                onChange={setElectionDate}
                value={electionDate}
              />
            </th>
          </tr>
        </table>
      </div>
      <div id="submit-container">
        {errorText && <p>{errorText}</p>}
        <button type="button" onClick={onSubmitPress}>
          Submit
        </button>
      </div>
      <Rodal visible={successModalVisible} onClose={() => setSuccessModalVisible(false)}>
        <div id="modal-success-content">
          <h2>Success!</h2>
          <p>We&apos;ve successfully added this election to our system.</p>
          <p>It will appear on the website once our moderators review it.</p>
          <button type="button" onClick={() => history.push('/elections')}>
            Back To Elections
          </button>
        </div>
      </Rodal>
      <Rodal visible={modalVisible} onClose={() => setModalVisible(false)}>
        <div id="modal-no-auth-content">
          <h2>Uh oh!</h2>
          <p>Looks like you&apos;re not logged in.</p>
          <p>You must have an account to report elections.</p>
          <h4 id="auth-prompt">Please <Link to="/sign-up">sign up</Link> or <Link to="/login">login</Link> to report a new election.</h4>
        </div>
      </Rodal>
    </div>
  );
};

export default NewElection;
